import { useNavigate } from "react-router-dom";

import { PageContainer } from "@/features/ui";

import { InvertedStandardPurchaseOrderForm } from "@/features/purchase-orders";
import { apiOutletClient, getErrorMessage } from "@/features/shared";
import { useSnackbar } from "@/features/ui";

import { Button } from "@mui/material";

export const CreateInvertedStandardPurchaseOrder = () => {
  const navigate = useNavigate();
  const { showSnackbar } = useSnackbar();

  const handleSubmit = async (formData) => {
    try {
      const { sellerId, ...payload } = formData;

      await apiOutletClient.post("purchase-orders/standard/inverted", payload, {
        headers: {
          "Outlet-Id": sellerId,
        },
      });
      navigate(-1);
    } catch (error) {
      showSnackbar(
        getErrorMessage(error, "Gagal membuat pesanan pembelian")
      );
    }
  };

  return (
    <PageContainer
      maxWidth="xl"
      title="Buat Pesanan Pembelian Bulk"
      breadcrumbs={[
        { title: "Pesanan Pembelian", path: "/procurement/purchase-orders/standard" },
        { title: "Tambah" },
      ]}
    >
      <InvertedStandardPurchaseOrderForm
        onSubmit={handleSubmit}
        renderActionButton={({ isSubmitting }) => (
          <Button
            type="submit"
            variant="contained"
            loading={isSubmitting}
          >
            Tambah
          </Button>
        )}
      />
    </PageContainer>
  );
};
